import { useContext, createContext } from 'react';

export const WaterCoolerContext = createContext(null);

export function useWaterCoolerContext() {
  return useContext(WaterCoolerContext);
}
